import { render, staticRenderFns } from "./UserInputButton.vue?vue&type=template&id=521df9b4&scoped=true"
import script from "./UserInputButton.vue?vue&type=script&lang=js"
export * from "./UserInputButton.vue?vue&type=script&lang=js"
import style0 from "./UserInputButton.vue?vue&type=style&index=0&id=521df9b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521df9b4",
  null
  
)

export default component.exports